module.exports = __webpack_public_path__ + "img/rolr-redesign.9dc168e6.jpg";